var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, PCSS, PropertyChangeEventName, Utils, ViewChild } from '@pacem/pacem-core';
import { PacemDataSourceElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
let PacemRadioListElement = class PacemRadioListElement extends PacemDataSourceElement {
    acceptValue(val) {
        // no need to implement
    }
    constructor() {
        super();
        this['key'] = '_' + Utils.uniqueCode();
    }
    get inputFields() {
        return [];
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'disabled') {
            this._disable.model = val;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._disable.model = this.disabled;
    }
    toggleReadonlyView(readonly) {
        this._repeater.hidden = readonly;
        this._span.hidden = !readonly;
    }
    _selectionChanged(evt, index, item) {
        if (evt.detail.propertyName === 'selected' && evt.detail.currentValue === true) {
            this._selectedValue = this.mapEntityToValue(this.datasource[index]);
            this.changeHandler(evt);
        }
    }
    onChange(evt) {
        this.value = this._selectedValue;
        this.databind();
        return Utils.fromResult(this._selectedValue);
    }
};
__decorate([
    ViewChild(P + '-repeater')
], PacemRadioListElement.prototype, "_repeater", void 0);
__decorate([
    ViewChild(P + '-data')
], PacemRadioListElement.prototype, "_disable", void 0);
__decorate([
    ViewChild(`span.${PCSS}-readonly`)
], PacemRadioListElement.prototype, "_span", void 0);
PacemRadioListElement = __decorate([
    CustomElement({
        tagName: P + '-radio-list', template: `<${P}-repeater datasource="{{ :host.adaptedDatasource }}">
    <ol class="${PCSS}-radio-list ${PCSS}-viewfinder" pacem>
        <template>
            <li><${P}-radio disabled="{{ ::_disable.model || ^item.disabled }}" name="{{ :host.key, once }}" autobind="off" caption="{{ ^item.viewValue }}" value="{{ ^item.value }}" selected="{{ :host.isDataSourceItemSelected(^item, :host.value) }}"
on-focus=":host.focusHandler($event)" on-blur=":host.focusHandler($event)"
on-${PropertyChangeEventName}=":host._selectionChanged($event, ^index, ^item)"></${P}-radio></li>
        </template>
    </ol>
</${P}-repeater><span class="${PCSS}-readonly ${PCSS}-radio"><${P}-text text="{{ :host.viewValue }}"></${P}-text></span><${P}-data></${P}-data><${P}-content></${P}-content>`,
        shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemRadioListElement);
export { PacemRadioListElement };
